import urls from "../../global/constants/UrlConstants";
import customErrorHandler from "../../utils/customErrorHandler";
import { getNoAuthCallParams, makeCall } from "../../utils/service";

export async function login(username: string, password: string) {
  // password = "Admin@1234";

  var body;
  if (password.length) {
    body = { username: username.toLocaleLowerCase(), password: password };
  } else {
    body = {
      username: username.toLocaleLowerCase(),
    };
  }
  try {
    const callParams = getNoAuthCallParams("POST", body);
    const response: any = await makeCall(urls.login, callParams);
    return response;
  } catch (error: any) {
    console.log(error,"error while login")
    throw error;
  }
}
